import React from 'react';
import { Route, Routes } from 'react-router-dom';
// Lazy load LivesCheckout for the lives checkout route
const LivesCheckout = React.lazy(() => import('../pages/games/LivesCheckout'));
const LivesInfo = React.lazy(() => import('../pages/games/LivesInfo'));
import { Header } from '../components/navMenu';
import { SignUp } from '../pages/auth/signUp';
import { SignIn } from '../pages/auth/signIn';
import { Profile } from '../pages/profile';
import { CreatePackage } from '../pages/createPackage';
import { PackagesList } from '../pages/packagesList';
import { CreateDraw } from '../pages/createDraw';
import { CreatePromoDraw } from '../pages/createPromoDraw';
import { PromoDrawsList } from '../pages/promoDrawsList';
import PromoDrawSignup from '../pages/promoDrawSignup/PromoDrawSignup';
import { PackagesDetails } from '../pages/packagesDetails';
import { DrawDetails } from '../pages/drawDetails';
import { DrawsList } from '../pages/drawsList';
import { Welcome } from '../pages/welcomePage';
import { DrawInfo } from '../pages/drawInfo';
import { PackageInfo } from '../pages/packagesDetails';
import { Total } from '../pages/total';
import TermsManager, { TermsViewer } from '../pages/terms';
import { Payment } from '../pages/payment';
import { PATHS } from './routes';
import { GoogleAuth } from '../pages/googleAuth';
import { OtpVerification } from '../pages/auth/otp';
import { DrawMemberships, PackageMemberships } from '../pages/usersTicketList';
import { PrivacyPolicy } from '../pages/privacy-policy';
import { ResetPassword } from '../pages/auth/resetPassword';
import ProtectedRoute from '../guards/AuthGuards';
import GuestGuard from '../guards/GuestGuard';
import CustomerGuard from '../guards/CustomerGuard';
import AdminGuard from '../guards/AdminGuard';
import CustomerVerification from '../pages/customerVerification/CustomerVerification';
import CustomerPortal from '../pages/customerPortal/CustomerPortal';
import CustomerSignIn from '../pages/CustomerSignIn/customerSignIn';
import { RewardsCatalogue } from '../pages/rewards';
import { PointsHistory } from '../pages/pointsHistory';
import Perks from '../pages/perks/Perks';
import Games from '../pages/games/Games';
import Refund from '../pages/refund/Refund';
// Admin pages
import AdminLogin from '../pages/adminLogin/AdminLogin';
import AdminDashboard from '../pages/adminDashboard/AdminDashboard';
import AdminRewards from '../pages/adminRewards/AdminRewards';
import AdminRedemptionRequests from '../pages/adminRedemptionRequests/AdminRedemptionRequests';
import AdminPoints from '../pages/adminPoints/AdminPoints';
import AdminGames from '../pages/adminGames/AdminGames';

const Router = () => {
    return (
        <Routes>
            <Route
                path={PATHS.SIGNIN}
                element={
                    <GuestGuard>
                        <SignIn />
                    </GuestGuard>
                }
            />
            <Route
                path={PATHS.SIGNUP}
                element={
                    <GuestGuard>
                        <SignUp />
                    </GuestGuard>
                }
            />
            <Route
                path={PATHS.WELCOME}
                element={
                    <ProtectedRoute>
                        <Header title="Welcome" menuIcon={true} backIcon={false}>
                            <Welcome />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.PROFILE}
                element={
                    <ProtectedRoute>
                        <Header title="Profile" backIcon={true}>
                            <Profile />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.CREATE_PACKAGE}
                element={
                    <ProtectedRoute>
                        <Header title="Creating Membership" backIcon={true}>
                            <CreatePackage />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.PACKAGE_LIST}
                element={
                    <ProtectedRoute>
                        <Header title="Your Active Packages" backIcon={true}>
                            <PackagesList />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.EDIT_PACKAGE}
                element={
                    <ProtectedRoute>
                        <Header title="Edit Package" backIcon={true}>
                            <CreatePackage />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.PACKAGE_DITAILS}
                element={
                    <ProtectedRoute>
                        <Header title="Package Details" backIcon={true}>
                            <PackagesDetails />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.CREATE_DRAW}
                element={
                    <ProtectedRoute>
                        <Header title="Creating Draw" backIcon={true}>
                            <CreateDraw />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.CREATE_PROMO_DRAW}
                element={
                    <ProtectedRoute>
                        <Header title="Promotional QR Code Draw" backIcon={true}>
                            <CreatePromoDraw />
                        </Header>
                    </ProtectedRoute>
                }
            />
            <Route
                path={PATHS.PROMO_DRAW_LIST}
                element={
                    <ProtectedRoute>
                        <Header title="Your Promotional Draw List" backIcon={true}>
                            <PromoDrawsList />
                        </Header>
                    </ProtectedRoute>
                }
            />

            {/* MANAGE_REWARDS route removed - now admin-only */}

            <Route
                path={PATHS.EDIT_PROMO_DRAW}
                element={
                    <ProtectedRoute>
                        <Header title="Edit Promotional Draw" backIcon={true}>
                            <CreatePromoDraw />
                        </Header>
                    </ProtectedRoute>
                }
            />

            {/* More specific route first - promo draw with tracking slug */}
            <Route
                path={PATHS.PROMO_DRAW_LINK}
                element={
                    <Header title="Join Promotional Draw" fullHeight={false}>
                        <PromoDrawSignup />
                    </Header>
                }
            />
            {/* Less specific route second - promo draw signup */}
            <Route
                path={PATHS.PROMO_DRAW_SIGNUP}
                element={
                    <Header title="Join Promotional Draw" fullHeight={false}>
                        <PromoDrawSignup />
                    </Header>
                }
            />
            <Route
                path={PATHS.EDIT_DRAW}
                element={
                    <ProtectedRoute>
                        <Header title="Edit Draw" backIcon={true}>
                            <CreateDraw />
                        </Header>
                    </ProtectedRoute>
                }
            />

            <Route
                path={PATHS.TERMS}
                element={
                    <ProtectedRoute>
                        <Header title="Terms & Conditions" backIcon={true}>
                            <TermsManager />
                        </Header>
                    </ProtectedRoute>
                }
            />

            <Route
                path={PATHS.PUBLIC_TERMS}
                element={
                    <Header title="Terms & Conditions" backIcon>
                        <TermsViewer />
                    </Header>
                }
            />

            <Route
                path={PATHS.DRAW_LIST}
                element={
                    <ProtectedRoute>
                        <Header title="Your Draw List" backIcon={true}>
                            <DrawsList />
                        </Header>
                    </ProtectedRoute>
                }
            />

            <Route
                path={PATHS.DRAW_USERS}
                element={
                    <ProtectedRoute>
                        <Header title="Draw Memberships List" backIcon={true}>
                            <DrawMemberships />
                        </Header>
                    </ProtectedRoute>
                }
            />

            <Route
                path={PATHS.PACKAGE_USERS}
                element={
                    <ProtectedRoute>
                        <Header title="Package Memberships List" backIcon={true}>
                            <PackageMemberships />
                        </Header>
                    </ProtectedRoute>
                }
            />

            <Route
                path={PATHS.DRAW_DETAILS}
                element={
                    <ProtectedRoute>
                        <Header title="Draw Details" backIcon={true}>
                            <DrawDetails />
                        </Header>
                    </ProtectedRoute>
                }
            />

            {/* More specific route first - draw info with tracking slug */}
            <Route
                path={PATHS.DRAW_INFO_LINK}
                element={
                    <Header title="Draw Info">
                        <DrawInfo />
                    </Header>
                }
            />
            {/* Less specific route second - regular draw info */}
            <Route
                path={PATHS.DRAW_INFO}
                element={
                    <Header title="Draw Info">
                        <DrawInfo />
                    </Header>
                }
            />
            <Route
                path={PATHS.PACKAGE_INFO}
                element={
                    <Header title="Package Info">
                        <PackageInfo />
                    </Header>
                }
            />
            <Route
                path={PATHS.TOTAL}
                element={
                    <Header title="Totla Cost" backIcon>
                        <Total />
                    </Header>
                }
            />
            <Route
                path={PATHS.DRAW_PAYMENT}
                element={
                    <Header title="Payment">
                        <Payment />
                    </Header>
                }
            />

            <Route
                path={PATHS.PACKAGE_PAYMENT}
                element={
                    <Header title="Payment">
                        <Payment />
                    </Header>
                }
            />

            <Route
                path="/payment"
                element={
                    <Header title="Payment">
                        <Payment />
                    </Header>
                }
            />

            <Route
                path={PATHS.PRIVACY}
                element={
                    <Header title="Privacy Policy">
                        <PrivacyPolicy />
                    </Header>
                }
            />

            <Route
                path={PATHS.RESET_PASS}
                element={
                    <Header title="Reset Password">
                        <ResetPassword />
                    </Header>
                }
            />

            <Route path={PATHS.GOOGLE} element={<GoogleAuth />} />
            <Route path={PATHS.OTP} element={<OtpVerification />} />

            <Route
                path={PATHS.CUSTOMER_VERIFICATION}
                element={
                    <Header title="Verify Email">
                        <CustomerVerification />
                    </Header>
                }
            />

            <Route
                path={PATHS.CUSTOMER_PORTAL}
                element={
                    <CustomerGuard>
                        <CustomerPortal />
                    </CustomerGuard>
                }
            />

            <Route
                path={PATHS.CUSTOMER_SIGNIN}
                element={
                    <Header title="Sign In">
                        <CustomerSignIn />
                    </Header>
                }
            />

            <Route
                path={PATHS.REWARDS_CATALOGUE}
                element={
                    <CustomerGuard>
                        <RewardsCatalogue />
                    </CustomerGuard>
                }
            />

            <Route
                path={PATHS.POINTS_HISTORY}
                element={
                    <CustomerGuard>
                        <PointsHistory />
                    </CustomerGuard>
                }
            />

            <Route
                path={PATHS.PERKS}
                element={
                    <CustomerGuard>
                        <Perks />
                    </CustomerGuard>
                }
            />


            <Route
                path={PATHS.CUSTOMER_GAMES}
                element={
                    <CustomerGuard>
                        <Games />
                    </CustomerGuard>
                }
            />

            <Route
                path="/customer/games/lives/checkout"
                element={
                    <CustomerGuard>
                        <React.Suspense fallback={<div>Loading...</div>}>
                            <LivesCheckout />
                        </React.Suspense>
                    </CustomerGuard>
                }
            />

            <Route
                path="/customer/games/lives/info"
                element={
                    <CustomerGuard>
                        <Header title="Extra Lives" backIcon>
                            <React.Suspense fallback={<div>Loading...</div>}>
                                <LivesInfo />
                            </React.Suspense>
                        </Header>
                    </CustomerGuard>
                }
            />

            <Route
                path="/refund"
                element={
                    <CustomerGuard>
                        <Refund />
                    </CustomerGuard>
                }
            />

            {/* REDEEM_REQUESTS route removed - now admin-only */}

            {/* Admin Routes */}
            <Route
                path={PATHS.ADMIN_LOGIN}
                element={<AdminLogin />}
            />
            <Route
                path={PATHS.ADMIN_DASHBOARD}
                element={
                    <AdminGuard>
                        <AdminDashboard />
                    </AdminGuard>
                }
            />
            <Route
                path={PATHS.ADMIN_REWARDS}
                element={
                    <AdminGuard>
                        <AdminRewards />
                    </AdminGuard>
                }
            />
            <Route
                path={PATHS.ADMIN_REDEMPTION_REQUESTS}
                element={
                    <AdminGuard>
                        <AdminRedemptionRequests />
                    </AdminGuard>
                }
            />
            <Route
                path={PATHS.ADMIN_POINTS}
                element={
                    <AdminGuard>
                        <AdminPoints />
                    </AdminGuard>
                }
            />
            <Route
                path={PATHS.ADMIN_GAMES}
                element={
                    <AdminGuard>
                        <AdminGames />
                    </AdminGuard>
                }
            />

            <Route
                path="*"
                element={
                    <Header title="" backIcon>
                        <p className="text-2xl font-semibold">404 Page Not Found !</p>
                    </Header>
                }
            />
        </Routes>
    );
};

export default Router;
